import type { PeriodActivityUser } from "@/lib/api/admin";

export type SortKey = keyof Omit<PeriodActivityUser, "userId"> | "total";
export type SortDir = "asc" | "desc";

export function getActivityTotal(row: PeriodActivityUser): number {
  return (
    row.epicRequestsCreated +
    row.epicsCreated +
    row.featuresCompleted +
    row.tasksCompleted +
    row.epicsCompleted
  );
}

export function sortActivityUsers(
  data: PeriodActivityUser[],
  sortKey: SortKey,
  sortDir: SortDir,
): PeriodActivityUser[] {
  return [...data].sort((a, b) => {
    let aVal: string | number;
    let bVal: string | number;

    if (sortKey === "total") {
      aVal = getActivityTotal(a);
      bVal = getActivityTotal(b);
    } else if (sortKey === "userName" || sortKey === "userEmail") {
      aVal = a[sortKey].toLowerCase();
      bVal = b[sortKey].toLowerCase();
    } else {
      aVal = a[sortKey as keyof PeriodActivityUser] as number;
      bVal = b[sortKey as keyof PeriodActivityUser] as number;
    }

    if (aVal < bVal) return sortDir === "asc" ? -1 : 1;
    if (aVal > bVal) return sortDir === "asc" ? 1 : -1;
    return 0;
  });
}
